@if (formReady$ | async) {
  @if (notificationsEnabled$ | async) {
    @if (
      (selectedPanelSection$ | async) === null) {
      @if (businessName$ | async; as business) {
        <div
          class="atlas-navbar__location"
          >
          <div class="atlas-navbar__location__business-name">
            {{ business }}
          </div>
          @if (address$ | async; as address) {
            <div
              class="atlas-navbar__location__address"
              >
              {{ address }}
            </div>
          }
        </div>
      }
      @if (globalSettings$ | async; as globalSettings) {
        <atlas-panel
          [collapsible]="true"
          >
          <atlas-panel-header>
            <atlas-panel-title>
              {{ 'VBC_NOTIFICATIONS.GLOBAL_SETTINGS' | translate }}
            </atlas-panel-title>
          </atlas-panel-header>
          <atlas-panel-content>
            <div class="atlas-navbar__accounts-form-settings__global">
              @for (global of globalSettings; track global) {
                <atlas-slide-toggle
                  [label]="global.title"
              [ngModel]="
                checked.get(checkboxId(global.id, global.id, Medium.GLOBAL))
              "
              (ngModelChange)="
                checked.set(
                  checkboxId(global.id, global.id, Medium.GLOBAL),
                  $event
                )
              "
                ></atlas-slide-toggle>
              }
            </div>
          </atlas-panel-content>
        </atlas-panel>
      }
      @if (reportSettings$ | async; as reportSettings) {
        <atlas-panel
          [collapsible]="true"
          >
          <atlas-panel-header>
            <atlas-panel-title>
              {{ 'VBC_NOTIFICATIONS.REPORTS' | translate }}
            </atlas-panel-title>
          </atlas-panel-header>
          <atlas-panel-content>
            <div class="atlas-navbar__accounts-form-settings__medium-header">
              <div class="atlas-navbar__accounts-form-settings__medium-container">
                @for (medium of reportMediums; track medium) {
                  <div
                    class="atlas-navbar__accounts-form-settings__medium"
                    >
                    {{ getTranslationKeyForMedium(medium) | translate }}
                  </div>
                }
              </div>
            </div>
            @for (report of reportSettings; track report) {
              <div
                class="atlas-navbar__accounts-form-settings__activity"
                >
                <div
                  class="atlas-navbar__accounts-form-settings__activity-container"
                  >
                  <div
                    class="atlas-navbar__accounts-form-settings__title-container"
                    >
                    <div class="atlas-navbar__accounts-form-settings__title">
                      {{ report.title }}
                    </div>
                    @if (!!report.description) {
                      <div
                        class="atlas-navbar__accounts-form-settings__description"
                        >
                        {{ report.description }}
                      </div>
                    }
                  </div>
                  <div
                    class="atlas-navbar__accounts-form-settings__medium-container"
                    >
                    @for (rm of report.mediums; track rm) {
                      <div
                        class="atlas-navbar__accounts-form-settings__medium"
                        >
                        <div
                          class="atlas-navbar__accounts-form-settings__medium__label"
                          >
                          {{ getTranslationKeyForMedium(rm.medium) | translate }}
                        </div>
                        <atlas-checkbox
                          class="atlas-navbar__accounts-form-settings__medium__input"
                    [ngModel]="
                      checked.get(checkboxId(rm.id, report.id, rm.medium))
                    "
                    (ngModelChange)="
                      checked.set(
                        checkboxId(rm.id, report.id, rm.medium),
                        $event
                      )
                    "
                        ></atlas-checkbox>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </atlas-panel-content>
        </atlas-panel>
      }
      @for (panel of panelSections$ | async; track panel) {
        <atlas-panel
          class="atlas-navbar__accounts-form-settings__panel-section"
          >
          <atlas-panel-header
            class="atlas-navbar__accounts-form-settings__panel-header"
            >
            <atlas-panel-title
              class="atlas-navbar__accounts-form-settings__panel-title"
              (click)="setSelectedPanelSection(panel)"
              >
              {{ panel.title }}
            </atlas-panel-title>
            <atlas-panel-description>
              <div class="atlas-navbar__accounts-form-settings__toggle-button">
                <button
                  atlasIconButton
                  (click)="clickCategoryIcon(panel, $event)"
                  >
                  <i class="material-icons">{{ getCategoryIcon(panel) }}</i>
                </button>
                <span>{{ getCategoryEnabledState(panel) | translate }}</span>
              </div>
            </atlas-panel-description>
          </atlas-panel-header>
          <div class="atlas-navbar__account-form-settings__panel-action">
            <button
              atlasIconButton
              class="atlas-navbar__account-form-settings__forward-icon"
              (click)="setSelectedPanelSection(panel)"
              >
              <i class="material-icons">keyboard_arrow_right</i>
            </button>
          </div>
        </atlas-panel>
      }
    } @else {
      @if (selectedPanelSection$ | async; as panel) {
        <div
          class="atlas-navbar__accounts-form-settings__selected-settings-header"
          >
          <div
          class="
            atlas-navbar__accounts-form-settings__selected-settings-header-title
          "
            (click)="setSelectedPanelSection(null)"
            >
            <button atlasIconButton>
              <i class="material-icons">arrow_back</i>
            </button>
            <div>
              {{ panel.title }}
            </div>
          </div>
          <div
          class="
            atlas-navbar__accounts-form-settings__panel-header__toggle-button
            atlas-navbar__accounts-form-settings__selected-settings-toggle
          "
            >
            <div class="atlas-navbar__accounts-form-settings__toggle-button">
              <button atlasIconButton (click)="clickCategoryIcon(panel, $event)">
                <i class="material-icons">{{ getCategoryIcon(panel) }}</i>
              </button>
              <span>{{ getCategoryEnabledState(panel) | translate }}</span>
            </div>
          </div>
        </div>
        <atlas-accordion>
          @for (activity of panel.activities; track activity) {
            <atlas-panel
              [collapsed]="true"
              [collapsible]="$safeNavigationMigration(activity?.tags?.length) > 0"
              >
              <atlas-panel-header
                class="atlas-navbar__accounts-form-settings__panel-header"
                >
                <atlas-panel-title
                  class="atlas-navbar__accounts-form-settings__activity-title"
                  >
                  <div>
                    {{ activity.title }}
                  </div>
                </atlas-panel-title>
                <atlas-panel-description
                  class="atlas-navbar__accounts-form-settings__activity-description"
                  >
                  <div>
                    {{ activity.description }}
                  </div>
                  <div
                class="
                  atlas-navbar__accounts-form-settings__activity-title__toggle-spacer
                "
                    >
                    @for (medium of availableMediums; track medium) {
                      <div
                        class="atlas-navbar__accounts-form-settings__medium"
                        >
                        <atlas-slide-toggle
                          class="atlas-navbar__accounts-form-settings__medium__input"
                    [disabled]="
                      isMediumDisabled(activity.enabledMediums, medium)
                    "
                    [ngModel]="
                      checked.get(
                        checkboxId(
                          activity.id,
                          $safeNavigationMigration(getMedium(activity.enabledMediums, medium)?.id),
                          medium
                        )
                      )
                    "
                    (ngModelChange)="
                      checked.set(
                        checkboxId(
                          activity.id,
                          $safeNavigationMigration(getMedium(activity.enabledMediums, medium)?.id),
                          medium
                        ),
                        $event
                      )
                    "
                    [atlasTooltip]="
                      (getTranslationKeyForMedium(medium) | translate) +
                      ' ' +
                      (getDisabledTooltip(activity.enabledMediums, medium)
                        | translate)
                    "
                          [label]="getTranslationKeyForMedium(medium) | translate"
                    [atlasTooltipDisabled]="
                      !isMediumDisabled(activity.enabledMediums, medium)
                    "
                        ></atlas-slide-toggle>
                      </div>
                    }
                  </div>
                </atlas-panel-description>
              </atlas-panel-header>
              <atlas-panel-content
                class="atlas-navbar__accounts-form-settings__activity-panel-content"
                >
                @if (activity.tags.length > 0) {
                  @for (tag of activity.tags; track tag) {
                    <div
                class="
                  atlas-navbar__accounts-form-settings__activity
                  atlas-navbar__accounts-form-settings__activity--tag
                "
                      >
                      <div
                  class="
                    atlas-navbar__accounts-form-settings__activity-tag-container
                  "
                        >
                        <div
                    class="
                      atlas-navbar__accounts-form-settings__title-container
                      atlas-navbar__accounts-form-settings__title-container--tag
                    "
                          >
                          <div class="atlas-navbar__accounts-form-settings__title">
                            {{ tag.title }}
                          </div>
                          @if (!!tag.description) {
                            <div
                              class="atlas-navbar__accounts-form-settings__description"
                              >
                              {{ tag.description }}
                            </div>
                          }
                        </div>
                        <div
                    class="
                      atlas-navbar__accounts-form-settings__tag-medium-container
                    "
                          >
                          @for (medium of availableMediums; track medium) {
                            <div
                              class="atlas-navbar__accounts-form-settings__medium"
                              >
                              <atlas-slide-toggle
                        class="
                          atlas-navbar__accounts-form-settings__medium__input
                        "
                        [disabled]="
                          isMediumDisabled(activity.enabledMediums, medium)
                        "
                        [ngModel]="
                          checked.get(
                            checkboxId(
                              tag.id,
                              $safeNavigationMigration(getMedium(activity.enabledMediums, medium)?.id),
                              medium
                            )
                          )
                        "
                        (ngModelChange)="
                          checked.set(
                            checkboxId(
                              tag.id,
                              $safeNavigationMigration(getMedium(activity.enabledMediums, medium)?.id),
                              medium
                            ),
                            $event
                          )
                        "
                        [atlasTooltip]="
                          (getTranslationKeyForMedium(medium) | translate) +
                          ' ' +
                          (getDisabledTooltip(activity.enabledMediums, medium)
                            | translate)
                        "
                                [label]="getTranslationKeyForMedium(medium) | translate"
                        [atlasTooltipDisabled]="
                          !isMediumDisabled(activity.enabledMediums, medium)
                        "
                              ></atlas-slide-toggle>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                }
              </atlas-panel-content>
            </atlas-panel>
          }
        </atlas-accordion>
      }
    }
  } @else {
    <div class="atlas-navbar__empty">
      <div class="atlas-navbar__empty__icon">
        <i class="material-icons">notifications_off</i>
      </div>
      {{ 'NOTIFICATIONS.SETTINGS.ALL_DISABLED' | translate }}
    </div>
  }
} @else {
  @if (!error) {
    <div class="atlas-navbar__loading">
      <atlas-loader [size]="24"></atlas-loader>
    </div>
  }
  @if (error) {
    <div class="atlas-navbar__empty">
      <div class="atlas-navbar__empty__icon">
        <i class="material-icons">error</i>
      </div>
      {{ 'NOTIFICATIONS.SETTINGS.LOAD_FAILURE' | translate }}
    </div>
  }
}

